import { stdObject } from "../data/types/stdObject";

export const reorderHeaders = (list: stdObject[]) => {
  const tempHeaders: stdObject = {};
  list.forEach((e: any) => {
    if (!tempHeaders[e.GRUCAB]) {
      tempHeaders[e.GRUCAB] = { default: [], user: [] };
    }
    if (e.USUCAB === 0) {
      tempHeaders[e.GRUCAB].default.push(e);
    } else {
      tempHeaders[e.GRUCAB].user.push(e);
    }
  });
  return tempHeaders;
};
